import request from '@/plugins/request';
import axios from '@/plugins/axios';
export function xhs_note(params) {
    return request  ({
      url: '/api/xhs_note',
      method: 'get',
      params
    });
  }

  export function xhs_note2(params) {
    return request  ({
      url: '/api/xhs_note2',
      method: 'get',
      params
    });
  }

  export function xhs_note3(params) {
    return request  ({
      url: '/api/xhs_note3',
      method: 'get',
      params
    });
  }

   export function xhs_note8(params) {
    return request  ({
      url: '/api/xhs_note8',
      method: 'get',
      params
    });
  }

  export function xhs_note_comments(params) {
    return request  ({
      url: '/api/xhs_note_comments',
      method: 'get',
      params
    });
  }

  export function xhs_note_comments2(params) {
    return request  ({
      url: '/api/xhs_note_comments2',
      method: 'get',
      params
    });
  }

  export function xhs_note_comments3(params) {
    return request  ({
      url: '/api/xhs_note_comments3',
      method: 'get',
      params
    });
  }

  export function xhs_note_comments8(params) {
    return request  ({
      url: '/api/xhs_note_comments8',
      method: 'get',
      params
    });
  }

  export function delete_xhs_note(user_id) {
    return request({
      url: `/xhs_note/${user_id}`, // 使用模板字符串插入 taskId
      method: 'delete',
    });
  }
  
  export function delete_xhs_note_comment(user_id) {
    return request({
      url: `/xhs_note_comment/${user_id}`, // 使用模板字符串插入 taskId
      method: 'delete',
    });
  }